var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElektronik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 40,
    viewBox: "0 0 55 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2371_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1967 3.26025L3.8125 6.92449L7.24866 28.7417L32.0907 23.0509L29.1967 3.26025ZM4.88186 7.71342L28.4077 4.32213L31.04 22.3367L8.01515 27.6087L4.88186 7.71342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3436 28.5548L36.4956 23.7427C36.1292 23.638 35.6057 23.5894 35.2057 23.6155C35.2057 23.608 35.2057 23.6043 35.2057 23.5968L32.035 1.62637C31.8929 0.616836 30.9507 -0.127228 29.9112 0.0223325L2.11911 3.89595C1.09088 4.04177 0.37299 4.99522 0.518812 6.03467L4.35878 30.6598C4.44852 31.2992 4.86355 31.8264 5.42066 32.0919V32.2227C5.42066 32.9145 5.89178 33.58 6.54237 33.8118L23.5474 39.8616C23.8054 39.955 24.127 40.0036 24.441 40.0036C24.6803 40.0036 24.9196 39.9775 25.1215 39.9214L53.3362 32.0844C54.0167 31.8937 54.5326 31.2207 54.5326 30.514V30.1364C54.5326 29.4334 54.0204 28.7567 53.3436 28.5622M6.22081 30.4168L6.20959 30.3944L2.38084 5.74677L30.1842 1.88436L33.3436 23.866L6.22081 30.4093V30.4168ZM52.6631 30.3345L24.6205 38.1229C24.527 38.1491 24.269 38.1416 24.1756 38.108L7.29017 32.1031V32.0769L33.6577 25.7206C33.7923 25.6982 33.9194 25.657 34.0428 25.6084L35.2991 25.485C35.4711 25.4701 35.8189 25.5 35.9871 25.5449L52.6669 30.3121V30.3345H52.6631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1045 26.4497C34.9549 26.4497 34.7343 26.4609 34.5287 26.5095C27.0843 28.3304 12.9022 31.7928 12.5433 31.8675C12.3301 31.8975 12.1656 32.0694 12.1432 32.2826C12.1207 32.4957 12.2479 32.6976 12.4498 32.7724L18.9482 35.0943C19.1538 35.1691 19.4305 35.2102 19.7072 35.2102C19.8418 35.2102 20.0475 35.199 20.2382 35.1504L41.8796 29.4409C42.3806 29.3101 42.4404 28.9885 42.4404 28.8539C42.4404 28.723 42.3918 28.4015 41.8908 28.2594L35.7962 26.532C35.6055 26.4796 35.3625 26.4497 35.1082 26.4497M20.0026 34.2456C19.8231 34.2942 19.4455 34.2792 19.2697 34.2156L14.2482 32.4209C18.3499 31.4301 29.4249 28.723 34.7568 27.4181C34.9512 27.3732 35.3513 27.377 35.5419 27.4331L40.5036 28.8389L20.0026 34.2456Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2371_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.0325,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElektronik);
export default __webpack_public_path__ + "static/media/icon-elektronik.fc3e138634dde40913fe6d993ffab77b.svg";
export { ForwardRef as ReactComponent };